import { api, getQueryString } from "../common/utils"
import { API_KEY_USAGE_ENDPOINT } from "../common/constants"

export interface ApiKeyUsageByKey {
  api_key_id: string
  key_name: string | null
  owner: string
  key_suffix: string
  hits: string
  endpoint_count: string
  ip_count: string
  first_seen: string
  last_seen: string
}

export interface ApiKeyUsageByEndpoint {
  api_key_id: string
  key_name: string | null
  owner: string
  endpoint: string
  request_method: string
  hits: string
  first_seen: string
  last_seen: string
}

export interface ApiKeyUsageDaily {
  day: string
  hits: string
  key_count: string
  endpoint_count: string
}

export interface ApiKeyUsageDetail {
  api_key_id: string
  endpoint: string
  method: string
  ip: string
  timestamp: string
}

export interface ApiKeyUsageDetailResponse {
  status: string
  usage: ApiKeyUsageDetail[]
  days: number
  group_by: string
  total?: number
  limit?: number
  offset?: number
}

type UsageParams = Record<string, string | number | boolean | undefined>

const apiUsage = {
  getDaily: async (params: UsageParams): Promise<ApiKeyUsageDaily[]> => {
    const { data } = await api.get(
      API_KEY_USAGE_ENDPOINT + getQueryString({ ...params, group_by: "daily" })
    )
    return data?.usage ?? []
  },
  getByKey: async (params: UsageParams): Promise<ApiKeyUsageByKey[]> => {
    const { data } = await api.get(
      API_KEY_USAGE_ENDPOINT + getQueryString({ ...params, group_by: "key" })
    )
    return data?.usage ?? []
  },
  getByEndpoint: async (
    params: UsageParams
  ): Promise<ApiKeyUsageByEndpoint[]> => {
    const { data } = await api.get(
      API_KEY_USAGE_ENDPOINT +
        getQueryString({ ...params, group_by: "endpoint" })
    )
    return data?.usage ?? []
  },
  getDetail: async (
    params: UsageParams
  ): Promise<ApiKeyUsageDetailResponse> => {
    const { data } = await api.get(
      API_KEY_USAGE_ENDPOINT + getQueryString({ ...params, group_by: "detail" })
    )
    return data
  }
}

export default apiUsage
